/**
 * Adhesive Bundle Functionality (LVT)
 * Handles flooring + adhesive bundle display, selection, pricing and cart add.
 * Namespaced to avoid clashing with the underlay bundle (window.bundleData).
 */

// Show adhesive bundle option when flooring is added
function showAdhesiveOption(flooringQuantity) {
    if (typeof window.adhesiveBundleData === 'undefined') {
        return; // No adhesive bundle data available
    }

    const bundleContainer = document.getElementById('adhesiveBundle');
    if (!bundleContainer) {
        return; // Bundle component not found
    }

    // Calculate adhesive quantity based on total area and selected adhesive's pack coverage
    const totalAreaEl = document.getElementById('totalArea');
    const totalArea = totalAreaEl ? (parseFloat(totalAreaEl.textContent) || 0) : 0;
    const currentAdhesiveId = window.adhesiveBundleData.adhesiveProductId;
    const currentAdhesiveData = window.adhesiveBundleData.adhesiveOptions[currentAdhesiveId];
    const packCoverage = currentAdhesiveData ? currentAdhesiveData.packCoverage : window.adhesiveBundleData.adhesiveCoverageRatio;
    const divisionResult = totalArea / packCoverage;
    const adhesiveQuantity = Math.max(1, Math.ceil(divisionResult));

    // Update bundle quantities
    document.getElementById('adhesiveBundleFlooringQuantity').textContent = flooringQuantity;
    document.getElementById('adhesiveBundleAdhesiveQuantity').textContent = adhesiveQuantity;

    renderAdhesivePricing(flooringQuantity, adhesiveQuantity);

    // Show the bundle container
    bundleContainer.style.display = 'block';

    // Scroll to bundle (smooth scroll)
    bundleContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
}

// Calculate and render bundle pricing (discount on adhesive only)
function renderAdhesivePricing(flooringQuantity, adhesiveQuantity) {
    const data = window.adhesiveBundleData;

    const flooringTotal = flooringQuantity * (data.flooringPrice / 100);
    const adhesiveTotal = adhesiveQuantity * (data.adhesivePrice / 100);
    const individualTotal = flooringTotal + adhesiveTotal;

    const discountPercentage = data.bundleDiscountPercentage || 0;
    const adhesiveDiscountAmount = Math.floor(adhesiveTotal * (discountPercentage / 100) * 100) / 100;
    const discountedAdhesiveTotal = adhesiveTotal - adhesiveDiscountAmount;
    const bundleTotal = flooringTotal + discountedAdhesiveTotal;

    document.getElementById('adhesiveBundleFlooringPrice').textContent = '£' + flooringTotal.toFixed(2);
    document.getElementById('adhesiveBundleAdhesivePrice').textContent = '£' + adhesiveTotal.toFixed(2);
    document.getElementById('adhesiveBundleIndividualTotal').textContent = '£' + individualTotal.toFixed(2);

    const discountedEl = document.getElementById('adhesiveBundleAdhesivePriceDiscounted');
    if (discountPercentage > 0) {
        discountedEl.textContent = '£' + discountedAdhesiveTotal.toFixed(2);
        discountedEl.style.display = 'block';
        document.getElementById('adhesiveBundleDiscount').textContent = '-£' + adhesiveDiscountAmount.toFixed(2);
        const savingsEl = document.getElementById('adhesiveBundleSavingsAmount');
        if (savingsEl) savingsEl.textContent = '£' + adhesiveDiscountAmount.toFixed(2);
    } else if (discountedEl) {
        discountedEl.style.display = 'none';
    }

    document.getElementById('adhesiveBundleTotal').textContent = '£' + bundleTotal.toFixed(2);
}

// Hide adhesive bundle
function hideAdhesiveBundle() {
    const bundleContainer = document.getElementById('adhesiveBundle');
    if (bundleContainer) {
        bundleContainer.style.display = 'none';
    }
}

// Toggle adhesive dropdown
function toggleAdhesiveDropdown() {
    const dropdown = document.getElementById('adhesiveDropdown');
    const trigger = document.getElementById('adhesiveSelectorTrigger');
    if (!dropdown || !trigger) {
        return;
    }
    const isOpen = dropdown.style.display !== 'none';
    if (isOpen) {
        closeAdhesiveDropdown();
    } else {
        openAdhesiveDropdown();
    }
}

function openAdhesiveDropdown() {
    const dropdown = document.getElementById('adhesiveDropdown');
    const trigger = document.getElementById('adhesiveSelectorTrigger');
    if (dropdown && trigger) {
        dropdown.style.display = 'block';
        trigger.classList.add('open');
        document.addEventListener('click', closeAdhesiveDropdownOnOutsideClick);
    }
}

function closeAdhesiveDropdown() {
    const dropdown = document.getElementById('adhesiveDropdown');
    const trigger = document.getElementById('adhesiveSelectorTrigger');
    if (dropdown && trigger) {
        dropdown.style.display = 'none';
        trigger.classList.remove('open');
        document.removeEventListener('click', closeAdhesiveDropdownOnOutsideClick);
    }
}

function closeAdhesiveDropdownOnOutsideClick(event) {
    const dropdown = document.getElementById('adhesiveDropdown');
    const trigger = document.getElementById('adhesiveSelectorTrigger');
    if (dropdown && trigger && !dropdown.contains(event.target) && !trigger.contains(event.target)) {
        closeAdhesiveDropdown();
    }
}

// Handle adhesive selection from dropdown option
function selectAdhesive(element) {
    const selectedAdhesiveId = element.dataset.id;

    if (!window.adhesiveBundleData || !window.adhesiveBundleData.adhesiveOptions) {
        return;
    }

    const adhesiveData = window.adhesiveBundleData.adhesiveOptions[selectedAdhesiveId];
    if (!adhesiveData) {
        console.error('Adhesive data not found for ID:', selectedAdhesiveId);
        return;
    }

    // Update trigger display
    const selectorImage = document.getElementById('adhesiveSelectorImage');
    const selectorTitle = document.getElementById('adhesiveSelectorTitle');
    if (selectorImage) {
        selectorImage.src = adhesiveData.image;
        selectorImage.alt = adhesiveData.title;
    }
    if (selectorTitle) {
        selectorTitle.textContent = adhesiveData.title + (adhesiveData.recommended ? ' (Recommended)' : '');
    }

    // Update bundle image
    const adhesiveImage = document.getElementById('bundleAdhesiveImage');
    if (adhesiveImage) {
        adhesiveImage.src = adhesiveData.image;
        adhesiveImage.alt = adhesiveData.title;
    }

    // Update adhesive description
    const adhesiveDescription = document.querySelector('.adhesive-bundle-item--adhesive .adhesive-bundle-item__description');
    if (adhesiveDescription) {
        adhesiveDescription.textContent = adhesiveData.recommended ? 'Recommended adhesive' : 'Selected adhesive';
    }

    // Update bundle data with new adhesive selection
    window.adhesiveBundleData.adhesiveProductId = adhesiveData.id;
    window.adhesiveBundleData.adhesiveVariantId = adhesiveData.variantId;
    window.adhesiveBundleData.adhesivePrice = adhesiveData.price;
    window.adhesiveBundleData.adhesiveProductTitle = adhesiveData.title;

    // Recalculate adhesive quantity based on new adhesive's pack coverage
    const totalAreaEl = document.getElementById('totalArea');
    const totalArea = totalAreaEl ? (parseFloat(totalAreaEl.textContent) || 0) : 0;
    const newAdhesiveQuantity = Math.max(1, Math.ceil(totalArea / adhesiveData.packCoverage));
    document.getElementById('adhesiveBundleAdhesiveQuantity').textContent = newAdhesiveQuantity;

    const flooringQuantity = parseInt(document.getElementById('adhesiveBundleFlooringQuantity').textContent) || 1;
    renderAdhesivePricing(flooringQuantity, newAdhesiveQuantity);

    closeAdhesiveDropdown();
}

// Add complete bundle (flooring + adhesive) to cart
function addAdhesiveBundleToCart() {
    if (typeof window.adhesiveBundleData === 'undefined') {
        console.error('Adhesive bundle data not available');
        return;
    }

    const flooringQuantity = parseInt(document.getElementById('adhesiveBundleFlooringQuantity').textContent) || 1;
    const adhesiveQuantity = parseInt(document.getElementById('adhesiveBundleAdhesiveQuantity').textContent) || 1;

    if (!window.adhesiveBundleData.flooringVariantId || !window.adhesiveBundleData.adhesiveVariantId) {
        console.error('Invalid variant IDs for adhesive bundle');
        alert('Error: Invalid product configuration. Please contact support.');
        return;
    }

    const bundleId = Date.now().toString();
    const discountText = document.getElementById('adhesiveBundleDiscount')?.textContent ?? '0';
    const items = [
        {
            id: window.adhesiveBundleData.flooringVariantId,
            quantity: flooringQuantity,
            properties: {
                '_bundle': 'flooring-adhesive',
                '_bundle_id': bundleId,
                '_bundle_type': 'flooring',
                '_bundle_category': 'lvt',
                '_bundle_discount': window.adhesiveBundleData.bundleDiscountPercentage,
                '_bundle_total_discount': discountText
            }
        },
        {
            id: window.adhesiveBundleData.adhesiveVariantId,
            quantity: adhesiveQuantity,
            properties: {
                '_bundle': 'flooring-adhesive',
                '_bundle_id': bundleId,
                '_bundle_type': 'adhesive',
                '_bundle_category': 'lvt',
                '_bundle_discount': window.adhesiveBundleData.bundleDiscountPercentage,
                '_bundle_total_discount': discountText
            }
        }
    ];

    const addButton = document.getElementById('addAdhesiveBundleToCart');
    const originalText = addButton ? addButton.innerHTML : '';
    if (addButton) {
        addButton.disabled = true;
        addButton.innerHTML = 'Adding...';
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
    })
    .then(response => response.json())
    .then(data => {
        if (data.status && (data.status === 'error' || (typeof data.status === 'number' && data.status >= 400))) {
            throw new Error(data.message || data.description || 'Failed to add to cart');
        }
        return data;
    })
    .then(data => {
        if (typeof showCartSuccessToast === 'function') {
            const bundleTotal = document.getElementById('adhesiveBundleTotal')?.textContent || '';
            showCartSuccessToast(1, `Bundle: ${window.adhesiveBundleData.flooringProductTitle} + ${window.adhesiveBundleData.adhesiveProductTitle} (${bundleTotal})`);
        }
        hideAdhesiveBundle();
        document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
        if (addButton) {
            addButton.disabled = false;
            addButton.innerHTML = originalText;
        }
    })
    .catch(error => {
        console.error('Error adding adhesive bundle to cart:', error);
        alert('Error adding to cart: ' + error.message);
        if (addButton) {
            addButton.disabled = false;
            addButton.innerHTML = originalText;
        }
    });
}

// Add just the flooring (no adhesive)
function addJustFlooringFromAdhesive() {
    if (typeof window.adhesiveBundleData === 'undefined') {
        return;
    }

    hideAdhesiveBundle();

    const flooringQuantity = parseInt(document.getElementById('adhesiveBundleFlooringQuantity').textContent) || 1;
    const variantId = window.adhesiveBundleData.flooringVariantId;

    if (typeof showCartSuccessToast === 'function') {
        showCartSuccessToast(flooringQuantity, window.adhesiveBundleData.flooringProductTitle || 'Flooring');
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: flooringQuantity })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        document.dispatchEvent(new CustomEvent('cart:update', { detail: data }));
        document.dispatchEvent(new CustomEvent('cart:item-added', { detail: data }));
    })
    .catch(error => {
        console.error('Error adding flooring to cart:', error);
    });
}
